export const PAGES = {
  report: {
    leaderboard: "/report/leaderboard",
  },
  homeScreen: "/",
  videoReview: "/video-review/:id/:jointId/:patientId/:side",
  patientOverview: "/patient-overview",
  patientDetails: "/patient-details/:id",
  userConfig: "/user-config",
  userProfile: "/user-profile",
  createTemplate: "/create-template",
  editTemplate: "/edit-template/:id",
  patientRecovery: "/patient-recovery/:id",
  superAdminOverview: "/super-admin-config",
  clinicOverview: "/clinic-overview",
  athleteOverview: "/athlete-overview",
};
